// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-icon{font-size:19px!important;font-family:Inter-Light;color:#000!important}", ""]);
// Exports
module.exports = exports;
